export const color = [
    'sky',
    'sea',
    'light',
    'cloud',
    'fog',
    'silver',
    'pidgeon',
    'lightSlathe',
    'slathe',
    'graphite',
    'success',
    'error',
    'warning',
    'sun',
    'sunset',
    'ice',
    'white',
    'info',
];
export const isColor = (x) => color.includes(x);
